import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import Modal from 'react-bootstrap/Modal';
import ModalHeader from '../../../components/ModalHeader';
import { Container, Row, Col } from 'react-bootstrap';
import Button from '../../../components/Button';
import ContactCard from '../../../components/ContactCard';
import IconButtonsStack from '../../../components/IconButtonsStack';

const iconButtons = [
  {
    variant: 'icon-default',
    icon: light('phone'),
    size: 'lg',
    tooltipText: 'Call to 555-555-5555',
  },
  {
    variant: 'icon-default',
    icon: light('globe'),
    size: 'lg',
    tooltipText: 'Open website in new tab',
  },
  {
    variant: 'icon-default',
    icon: light('file-pdf'),
    size: 'lg',
  },
];

const contactCards = [
  {
    titleIcon: light('tooth'),
    title: 'Dental',
    img: `${process.env.PUBLIC_URL}/${'aetna.png'}`,
    medicalGroup: 'DMO Plan',
    status: 'enrolled',
    statusIcon: light('circle-check'),
    contactButtons: <IconButtonsStack iconButtons={iconButtons} />,
  },

  {
    titleIcon: light('tooth'),
    title: 'Dental',
    img: `${process.env.PUBLIC_URL}/${'aetna.png'}`,
    medicalGroup: 'PPO Plan',
    contactButtons: <IconButtonsStack iconButtons={iconButtons} />,
  },
];

export type MedicalModalProps = {
  showDentalModal: boolean;
  handleCloseDentalModal: () => void;
};

function DentalModal({
  showDentalModal,
  handleCloseDentalModal,
}: MedicalModalProps) {
  return (
    <>
      <Modal
        className={'p-0'}
        show={showDentalModal}
        onHide={handleCloseDentalModal}
        dialogClassName="modal-xl"
        aria-labelledby="example-custom-modal-styling-title"
      >
        <ModalHeader
          leftIcon={light('tooth')}
          leftIconVariant={'icon-emphasized'}
        >
          <h4 className="text-sm-20-lg-32">Dental</h4>
        </ModalHeader>
        <Modal.Body>
          <Container className={'p-0'}>
            <Row>
              {contactCards.map((contactCard, idx) => {
                return (
                  <Col key={idx} className={'col-12 col-lg-4 mb-7 mb-lg-10'}>
                    <ContactCard
                      bg={'transperant-with-border'}
                      title={contactCard.title}
                      titleIcon={contactCard.titleIcon}
                      img={contactCard.img}
                      medicalGroup={contactCard.medicalGroup}
                      status={contactCard.status}
                      statusIcon={contactCard.statusIcon}
                      contactButtons={contactCard.contactButtons}
                    />
                  </Col>
                );
              })}
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer className={'pt-0'}>
          <Button
            variant="primary-outline"
            onMouseDown={handleCloseDentalModal}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default DentalModal;
